import React from 'react';
import { Field, Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import { Box, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import EyeClose from '../../assets/fonts/eye-close.svg';
import ConfirmacaoLogin from './ConfirmacaoLogin/ConfirmacaoLogin';
import ButtonMain from '../Shared/ButtonMain';
import LoaderMain from '../Shared/LoaderMain';
import TextFieldMain from '../Shared/TextFieldMain';
import useLoginHook from './useLoginHook';
import FundoPadrao from './FundoPadrao';
import './styles.scss';

const Login = ({ setEscopoAcesso }) => {
  const {
    valuesPassword,
    loginPending,
    tokenCodUser,
    emailUser,
    isPending,
    message,
    tela,
    handleClickShowPassword,
    handleMouseDownPassword,
    handleChangePassword,
    handleOnChangeInput,
    handleFormSubmit,
    setMessage,
    setTela,
    logar
  } = useLoginHook({ setEscopoAcesso });

  return (
    <FundoPadrao>
      <CardContent>
        <Box className="controle-loader">{loginPending && <LoaderMain />}</Box>
        {tela === 'login' && (
          <Grid container className={`${loginPending ? 'display-none' : ''}`}>
            <Grid item xl={1} lg={1} md={1} sm={1} xs={1} />
            <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
              <Typography variant="h5" className="texto-negrito texto-centro label-acessar-conta">
                Acesse sua conta
              </Typography>
              <Formik
                initialValues={{ login: '', password: '' }}
                validate={values => {
                  const errors = {};

                  if (!values.login.trim()) {
                    errors.login = 'Informe o login';
                  }
                  if (!values.password.trim()) {
                    errors.password = 'Informe a senha';
                  }

                  return errors;
                }}
                onSubmit={handleFormSubmit}
                validateOnChange={false}
                validateOnBlur={false}
              >
                {({ values, isSubmitting }) => {
                  const loginIsFilled = !!values.login?.trim();
                  const passwordIsFilled = !!values.password?.trim();

                  return (
                    <Form>
                      <Grid container>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                          <Typography className="texto-cor-label">Usuário</Typography>
                          <Field
                            placeholder="Email ou login"
                            variant="filled"
                            type="text"
                            name="login"
                            titulo="Login"
                            id="login"
                            size="small"
                            component={TextFieldMain}
                            inputClassName={`input-login w-100 ${loginIsFilled ? 'is-filled' : ''}`}
                            onChangeInput={handleOnChangeInput}
                            uppercase={false}
                            autoComplete="off"
                            disabled={isPending || isSubmitting}
                          />

                          <Typography className="texto-cor-label mt-3">Senha</Typography>
                          <Field
                            name="password"
                            id="password"
                            titulo="Senha"
                            variant="filled"
                            placeholder="Mínimo 8 caracteres"
                            component={TextFieldMain}
                            tipoComponente="outlineInput"
                            type={valuesPassword.showPassword ? 'text' : 'password'}
                            value={valuesPassword.password}
                            onChangeInput={handleChangePassword('password')}
                            size="small"
                            autoComplete="new-password"
                            inputClassName={`w-100 ${passwordIsFilled ? 'is-filled' : ''}`}
                            disabled={isPending || isSubmitting}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {valuesPassword.showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <img src={EyeClose} alt="icone olho fechado" />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />

                          {message && (
                            <Typography variant="subtitle1" className="texto-danger pad-10 texto-centro">
                              {message}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} className="mt-2">
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                          <ButtonMain
                            type="submit"
                            tipoBotao="principal "
                            disabled={isPending || isSubmitting || !loginIsFilled || !passwordIsFilled}
                            className={`button-cor-cliente min-heith-42 ${isPending ? 'loading' : ''}`}
                          >
                            {!isPending && <>Acessar</>}
                            {isPending && <CircularProgress size={24} color="inherit" />}
                          </ButtonMain>

                          <Box className="text-center mt-5 mb-5">
                            <Typography variant="subtitle1" className="texto-link-redefinir">
                              Não lembra sua senha? &nbsp;
                              <Link
                                className="link-criar-conta"
                                disabled={isPending || isSubmitting}
                                to="/forgot-password"
                              >
                                <Typography>Redefinir agora</Typography>
                              </Link>
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Form>
                  );
                }}
              </Formik>
            </Grid>
          </Grid>
        )}

        {tela === 'confirmacao' && (
          <ConfirmacaoLogin
            logar={logar}
            tokenCodUser={tokenCodUser}
            emailUser={emailUser}
            setTela={setTela}
            setMessageLogin={setMessage}
          />
        )}
      </CardContent>
    </FundoPadrao>
  );
};

export default Login;
